export default __webpack_public_path__ + "static/media/flame.3c21abc3.jpg";